import React from 'react';
import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { platformNotSupportedModalMessages as messages } from '../../CalendarLinks.messages';

const PlatformNotSupportedModal = () => (
  <Confirm title={<Message message={messages.title} />} acceptNode={<Message message={messages.continue} />}>
    <Message message={messages.body} />
  </Confirm>
);

export default PlatformNotSupportedModal;
